import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import FormCadastrarEditarCarteira from 'components/forms/FormCadastrarEditarCarteira';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import moment from 'moment';
import { useContext, useEffect, useMemo } from 'react';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export default function CadastrarCarteira() {
	const { setters } = useContext(SidebarHelpContext);
	const { setDataSidebar } = setters;

	const helpCadastroCarteira = useMemo(
		(): ISidebarHelp => ({
			title: 'Cadastrar Carteira de Pedidos',
			firstParagraph:
				'Para cadastrar uma nova carteira de cliente, selecione a Competência desejada e entre com os dados do tipo de carteira, Canal de Venda, Cliente, Família, código de produto, quantidade e receita bruta.',
			secondParagraph:
				'Para cadastrar uma carteira de pedidos, cadastre os canais de venda previamente em Cadastros > Comercial > Hierarquia, bem como os produtos em Cadastros > Produtos.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	useEffect(() => {
		setDataSidebar(helpCadastroCarteira);
	}, [helpCadastroCarteira, setDataSidebar]);

	const formInitialState = {
		data: moment().format('YYYY-MM-DD'),
		cliente_id: null,
		familia_id: null,
		produto_id: null,
		quantidade: null,
		canal_venda_id: null,
		receita_bruta: null,
		faturado: false,
		ruim: false,
	};

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='0px'>
				<FormCadastrarEditarCarteira initialState={formInitialState} />
			</Card>
		</Flex>
	);
}
